var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGithub = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "github account connect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.292969,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#1F408C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 6.29297C10.6583 6.29297 5.52185 11.3433 5.52185 17.5721C5.52185 22.5565 8.81032 26.7833 13.37 28.2735C13.9439 28.3797 14.1543 28.0306 14.1543 27.7312C14.1543 27.4633 14.1448 26.7536 14.14 25.8134C10.9472 26.4935 10.2738 24.3002 10.2738 24.3002C9.75153 22.9984 8.99684 22.6502 8.99684 22.6502C7.95712 21.951 9.07719 21.9653 9.07719 21.9653C10.2298 22.0438 10.8352 23.1275 10.8352 23.1275C11.8587 24.8521 13.5221 24.3537 14.1782 24.0658C14.2815 23.336 14.5771 22.8396 14.9052 22.5574C12.3561 22.2753 9.67692 21.3054 9.67692 16.9839C9.67692 15.7528 10.1217 14.7466 10.8582 13.9575C10.7291 13.6724 10.3417 12.5256 10.9586 10.9722C10.9586 10.9722 11.9199 10.6699 14.1151 12.1286C15.0334 11.878 16.009 11.7537 16.9846 11.7479C17.9603 11.7537 18.9359 11.878 19.8542 12.1286C22.035 10.6699 22.9963 10.9722 22.9963 10.9722C23.6132 12.5256 23.2258 13.6724 23.1111 13.9575C23.8428 14.7466 24.2876 15.7528 24.2876 16.9839C24.2876 21.3168 21.6046 22.2705 19.0507 22.5479C19.4524 22.8865 19.8255 23.578 19.8255 24.635C19.8255 26.1443 19.8111 27.3572 19.8111 27.7235C19.8111 28.0191 20.012 28.372 20.6002 28.2592C25.1924 26.7785 28.478 22.5488 28.478 17.5721C28.478 11.3433 23.3387 6.29297 16.9999 6.29297Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGithub);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/github.50dafc7769ab1948934206ad77ade505.svg";